<template>
  <div class="qrcode-container g-flex-c">
    <div class="qrcode">
      <img v-if="[0,-1].includes(qrStatus)" :src="qrUrl" alt="">
      <div v-if="[1,-1].includes(qrStatus)" class="cover g-flex-c">
        <img v-if="qrStatus === 1" src="../../../assets/image/success.png" alt="">
      </div>
    </div>
    <p v-if="qrStatus === 0">"一站一码"，需报名人本人微信扫码绑定</p>
    <p v-else-if="qrStatus === 1">扫码成功，请在手机上完成绑定</p>
    <p v-else>二维码已过期，请刷新</p>
    <div class="g-flex-c">
      <el-button @click="goPrev">上一步</el-button>
      <el-button v-if="qrStatus === -1" type="primary" @click="refresh">刷新</el-button>
    </div>
  </div>
</template>
<script>
import { queryQrCodeStatus, refreshQrcode } from '@/api/marketPromotion'

export default {
  name: 'second',
  props: ['qrUrl', 'recordId'],
  data () {
    return {
      timer: null,
      qrStatus: 0
    }
  },
  methods: {
    goPrev () {
      this.clearTimer()
      this.$parent.currentStep = 1
    },
    clearTimer () {
      clearInterval(this.timer)
      this.timer = null
    },
    async refresh () {
      const { code, result: { qrStatus, qrUrl } } = await refreshQrcode({ recordId: this.recordId })
      if (code !== 200) return
      this.qrUrl = qrUrl
      this.qrStatus = qrStatus
    }
  },
  created () {
    this.timer = setInterval(async () => {
      const { code, result: { qrStatus } } = await queryQrCodeStatus({ recordId: this.recordId })
      if (code !== 200) return
      this.qrStatus = qrStatus
      if (qrStatus === 2 || qrStatus === 3) {
        this.clearTimer()
        this.$emit('nextStep', qrStatus)
      }
    }, 5000)
  },
  beforeDestroy () {
    this.clearTimer()
  }
}
</script>
<style lang="less" scoped>
  @import url('./second.less');
</style>
